import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@/common/components/Grid/Grid';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { MARKET } from '@/common/constants/markets';
import { ProfileCard } from '@/common/containers/Dashboard/Profile/components/ProfileCard/ProfileCard';
import { IEmployee } from '@/common/integrations/menhir/employee/employee/employee.types';
import { useCountries } from '@/web/hooks/useCountries';
import { useMarket } from '@/web/hooks/useMarket';
import { AddressFormModal } from './components/AdressFormModal/AddressFormModal';

export type TAddressCardProps = {
  employee: IEmployee;
};

export function AddressCard({ employee }: TAddressCardProps) {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const { getCountryByCode } = useCountries();
  const countryName = getCountryByCode(employee.address.country)?.name ?? '';
  const { slug } = useMarket();
  return (
    <>
      <ProfileCard
        title={t('dashboard.personal_info.sections.address.title')}
        onEdit={() => setIsEditing(true)}
      >
        <LabeledValue
          label={t('dashboard.personal_info.sections.address.labels.address')}
          value={employee.address.addressLine1 || '—'}
        />
        <Grid gap="lg" columnBasis="basis-[12rem]">
          <LabeledValue
            label={t('dashboard.personal_info.sections.address.labels.zipcode')}
            value={employee.address.zipCode || '—'}
          />
          <LabeledValue
            label={t('dashboard.personal_info.sections.address.labels.city')}
            value={employee.address.city || '—'}
          />
          {slug === MARKET.ES && (
            <LabeledValue
              label={t(
                'dashboard.personal_info.sections.address.labels.province'
              )}
              value={employee.address.district || '—'}
            />
          )}
          <LabeledValue
            label={t('dashboard.personal_info.sections.address.labels.country')}
            value={countryName || '—'}
          />
        </Grid>
      </ProfileCard>
      {isEditing && (
        <AddressFormModal
          employee={employee}
          onClose={() => setIsEditing(false)}
        />
      )}
    </>
  );
}
